// src/layouts/BaseLayout.jsx
import { AppShell, Container } from '@mantine/core';
import { Outlet } from 'react-router-dom';
import TopNavbar from '../components/TopNavbar';

export default function BaseLayout() {
  return (
    <AppShell
      header={{ height: 65 }}
      padding="md"
      bg="gray.0"
    >
      <AppShell.Header>
        {/* Sidebar olmadığı için opened ve toggle proplarını göndermiyoruz. Sadece başlıkları yolluyoruz. */}
        <TopNavbar title="SMS Grup" highlight="Portal" showBackButton={false} />
      </AppShell.Header>

      <AppShell.Main>
        <Container fluid px={0}>
            {/* Alt sayfalar buraya yüklenecek (Örn: MainPortal, SubscriptionsPage) */}
            <Outlet /> 
        </Container>
      </AppShell.Main>
    </AppShell>
  );
}